import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/midders/Code/xedi-microservices/sdk-js/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { BorderBox, Flash } from '@primer/components';
import { Caption } from '@primer/gatsby-theme-doctocat';
import InlineCode from '@primer/gatsby-theme-doctocat/src/components/inline-code';
import { InfoIcon } from '@primer/styled-octicons';
import { GithubIssue } from '../../src/components';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`All documentation, including the framework and it's dependencies, are in the `}<inlineCode parentName="p">{`docs/`}</inlineCode>{` directory. This should be your working directory.`}</p>
    <h2>{`Environment`}</h2>
    <Flash mb={2} mdxType="Flash"><InfoIcon mr={1} mdxType="InfoIcon" />At present, you must use a copy of node locally on your machine to compile and use XEDI.js documentation. In the future, this will be containerized.
      <BorderBox mt={1} bg="white" mdxType="BorderBox">
    <GithubIssue issueId="58" mdxType="GithubIssue" />
      </BorderBox>
    </Flash>
    <p>{`Due to runtime bug in node 14.3, one our dependencies is unable to build. As such, you must use either:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`10.20.1`}</inlineCode>{` (`}<inlineCode parentName="li">{`lts/dubnium`}</inlineCode>{`)`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`12.17.0`}</inlineCode>{` (`}<inlineCode parentName="li">{`lts/erbium`}</inlineCode>{`)`}</li>
    </ul>
    <p>{`As soon as this is rectified, this requirement will be removed.`}</p>
    <h3>{`Variables`}</h3>
    <p>{`To allow various functionalities of the documentation to work, a personal access token is required. This should be placed within a `}<inlineCode parentName="p">{`.env`}</inlineCode>{` file in the root of the `}<inlineCode parentName="p">{`docs/`}</inlineCode>{` directory.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`GITHUB_TOKEN=<my personal access token>
`}</code></pre>
    <Caption mdxType="Caption">.env</Caption>
    <h2>{`Local Builds`}</h2>
    <p>{`The documentation framework ships with a development server that allows hotswap development.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`npm run develop
`}</code></pre>
    <Caption mdxType="Caption">Launching the development server</Caption>
This triggers a build, followed by the provision of a localhost link. It defaults to port <InlineCode mdxType="InlineCode">8000</InlineCode>, however if something is already using that port, the framework will use the next numerically available port.
    <Flash mt={2} mdxType="Flash"><InfoIcon mr={1} mdxType="InfoIcon" />If you are XEDI staff, when you go to <InlineCode mdxType="InlineCode">http://localhost:8000</InlineCode> you may find that your browser automatically may redirect your to <InlineCode mdxType="InlineCode">http://localhost:8000/dashboard</InlineCode>. This is because Traefik, our development loadbalancer issues a <InlineCode mdxType="InlineCode">308 Permanent Redirect</InlineCode> response when you go to <InlineCode mdxType="InlineCode">http://localhost:8000</InlineCode>
      <p>{`In this event, you will be greeted with a "Development 404" page. Simply select one of the pages in the site map displayed centrally in the page.`}</p>
      <BorderBox bg="white" mdxType="BorderBox">
    <GithubIssue issueId="57" mdxType="GithubIssue" />
      </BorderBox>
    </Flash>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      